import { Components, Theme } from '@mui/material';

import type { AdditionalColors } from '@/theme/PaletteOverrides.ts';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides extends AdditionalColors {}
}

declare module '@mui/material/ButtonBase' {
  interface ButtonPropsColorOverrides extends AdditionalColors {}
}

export const buttonComponentOverrides: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: () => ({
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
      '&:active': {
        boxShadow: 'none',
      },
      '&:focus': {
        boxShadow: 'none',
      },
    }),
  },
};
